import { CommonModule } from '@angular/common';
import { Component, HostListener } from '@angular/core';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AuthService } from '../../core/services/auth.service';

import { PublicFooterLayoutComponent } from '../public-footer-layout/public-footer-layout.component';

@Component({
    selector: 'app-member-layout',
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
        RouterLink,
        RouterLinkActive,
        PublicFooterLayoutComponent
    ],
    templateUrl: './member-layout.component.html',
    styleUrl: './member-layout.component.scss'
})
export class MemberLayoutComponent {

    public isUserMenuOpen: boolean = false;

    public readonly companyName: string = 'ANAMETA AI FRAMEWORK';

    public readonly userName: string;

    public sidebarCollapsed: boolean = false;

    public mobileMenuOpen: boolean = false;

    constructor(private readonly router: Router, private readonly auth: AuthService) {
        this.userName = this.auth.getUserEmail() ?? 'Unknown';
    }

    public toggleUserMenu(): void {
        this.isUserMenuOpen = !this.isUserMenuOpen;
    }

    public closeUserMenu(): void {
        this.isUserMenuOpen = false;
    }

    public logout(): void {
    

        localStorage.removeItem('access_token');
        sessionStorage.removeItem('access_token');

        this.closeUserMenu();

        void this.router.navigateByUrl('/login');
    }

    public ToggleSidebar(): void {
        this.sidebarCollapsed = !this.sidebarCollapsed;
    }

    public ToggleMobileMenu(): void {
        this.mobileMenuOpen = !this.mobileMenuOpen;
    }

    public CloseMobileMenu(): void {
        this.mobileMenuOpen = false;
    }

    @HostListener('document:click')
    public OnDocumentClick(): void {
        this.closeUserMenu();
    }

    @HostListener('window:resize', ['$event'])
    public OnWindowResize(event: Event): void {
        const windowObject: Window = event.target as Window;

        if (windowObject.innerWidth >= 1200) {
            this.mobileMenuOpen = false;
        }
    }

}